export default "__VITE_ASSET__DRQIhm4B__"